import { Toast } from "vant";
export default class AsrClient {
  constructor() {
    this.ws = null;
    // 录音id
    this.asrId = null;
    // 采样率
    this.sampleRate = 16000;
    // 比特率
    this.bits = 16;
    // 声道数
    this.channels = 1;
    // 是否启用标点
    this.enablePunc = true;
    this.modelName = "bigmodel";
    // 录音数据
    this.recordedChunks = [];
    // 完整转写文字
    this.fullTranscript = "";
    // 录音blob
    this.recordedBlob = null;
    // 音频流
    this.audioStream = null;
    // 等待final消息
    this.waitingForFinal = false;
    // 超时定时器
    this.finalTimeout = null;
    // 是否正在录音
    this.isRecording = false;
    // 是否暂停
    this.isPaused = false;
    // MediaRecorder
    this.mediaRecorder = null;
    // 采集的PCM16片段
    this.pcmChunks = [];
    // 保存所有上送的PCM数据用于调试
    this.sentPcmChunks = [];
    // 计时器相关属性
    this.startTime = null;
    this.pausedTime = 0;
    this.totalPausedDuration = 0;
    this.timerInterval = null;
    this.currentTime = 0;
    // 实时计时字段（外部可直接访问）
    this.currentTimeMs = 0; // 当前录音时长（毫秒）
    this.formattedTime = "00:00"; // 格式化时间（MM:SS）
    // 停止录音完成后的回调函数
    this.onStopCompleteCallback = null;
    // 默认录音最长时间
    this.defaultMaxDuration = 60 * 1000;
    // 是否因达到最大时长而暂停
    this.isPausedByMaxDuration = false;
    // 结束录音标识（由用户触发）
    this.isEndedByUser = false;
    // 是否已经收到过final信号
    this.isFinalReceived = false;
    // 转写文字更新回调函数
    this.onTranscriptUpdateCallback = null;
    // 音量更新回调函数
    this.onVolumeUpdateCallback = null;
    // 音频分析器
    this.analyser = null;
    this.volumeCheckInterval = null;
    // 实际采样率（Mac可能与目标采样率不同）
    this.actualSampleRate = null;
    this.needsResampling = false;
  }
  // 开始录音
  async startRecording() {
    // 清理之前的录音数据
    this.recordedChunks = [];
    this.pcmChunks = []; // 清理PCM数据缓存
    this.sentPcmChunks = []; // 清理上送的PCM数据缓存
    this.fullTranscript = "";
    this.segmentTexts = {};
    // 清理计时器数据
    this.resetTimer();
    // 重置最大时长暂停状态
    this.isPausedByMaxDuration = false;
    // 连接WebSocket
    let result = await this.connectWebSocket();
    console.log("连接WebSocket结果:", result);
    // 获取麦克风权限
    let result2 = await this.getMicrophone();
    console.log("获取麦克风权限结果:", result2);
    // 如果获取麦克风权限失败，直接返回，不执行后续代码
    if (!result2) {
      return false;
    }

    // 开始录音
    let result3 = await this.startAudioCapture();

    if (result && result2 && result3) {
      this.isRecording = true;
      this.isPaused = false;
      this.startTimer();
      return true;
    }
    return false;
  }
  //  连接WebSocket
  connectWebSocket() {
    return new Promise((resolve, reject) => {
      const appId = window.localStorage.getItem("appId_AI");
      const sessionId = window.localStorage.getItem("sessionId_AI");
      const wsUrl = `${process.env.VUE_APP_WS_HOST}/aiGateway/ai/asr?appId=${appId}&sessionId=${sessionId}`;
      console.log("连接WebSocket:", wsUrl);

      this.ws = new WebSocket(wsUrl);
      this.ws.onopen = () => {
        console.log("WebSocket连接已建立");
        // 发送开始消息（认证已在连接时完成）
        const startMessage = {
          type: "start",
          sampleRate: this.sampleRate,
          bits: this.bits,
          channels: this.channels,
          enablePunc: true,
          modelName: "bigmodel",
        };
        console.log("发送开始消息:", startMessage);
        this.ws.send(JSON.stringify(startMessage));
        resolve(true);
      };

      this.ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          // console.log("收到消息:", data);
          const messageType = data.messageType || data.type;

          switch (messageType) {
            case "connected":
              this.asrId = data.asrId;
              break;
            case "result":
              // 实时识别结果 - 显示当前片段文本
              if (data.text && data.text.trim()) {
                this.updateFullTranscript(data.seq, data.text);
              }
              break;

            case "pause":
              break;

            case "final":
              // 处理final消息，完成停止录音流程  后端如果返回了final消息，则认为达到录音时长
              this.handleFinalSignal();
              break;

            case "error":
              // 错误消息 - 统一处理不同的错误字段
              break;

            case "ack":
              // 确认消息
              break;

            default:
              // 处理特殊错误码
              if (data.code === "INVALID_SESSION") {
                // sessionId失效
                this.resetRecordingState();
              } else {
                console.log("未处理的消息类型:", messageType, data);
              }
              break;
          }
        } catch (error) {
          console.error("解析消息失败:", error);
        }
      };

      this.ws.onerror = (error) => {
        console.error("WebSocket错误:", error);
        this.resetRecordingState();
        console.log("WebSocket连接失败");
        resolve(false);
      };

      this.ws.onclose = (event) => {
        console.log("WebSocket连接关闭:", event.code, event.reason);
        if (this.isRecording) {
          this.resetRecordingState();
        }
        resolve(false);
      };
    });
  }
  //   获取麦克风权限
  async getMicrophone() {
    // 检查浏览器是否支持 mediaDevices API
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.error("当前环境不支持 getUserMedia API");
      Toast("当前访问环境不安全，无法使用麦克风功能。请使用 HTTPS 访问或在本地环境测试");
      return false;
    }

    return await navigator.mediaDevices
      .getUserMedia({
        audio: {
          sampleRate: this.sampleRate,
          channelCount: this.channels,
          echoCancellation: true,
          noiseSuppression: true,
        },
      })
      .then((stream) => {
        this.audioStream = stream;
        console.log("获取到音频流:", stream.getAudioTracks()[0].getSettings());
        return true;
      })
      .catch((err) => {
        console.log(err);
        Toast("未获取到麦克风权限，请去设置页面开启");
        return false;
      });
  }
  //   开始录音
  async startAudioCapture() {
    return new Promise(async (resolve, reject) => {
      try {
        // 同时启动AudioContext和MediaRecorder
        // AudioContext用于实时传输，MediaRecorder用于保存文件

        // 1. 启动MediaRecorder保存录音
        // 检查支持的MIME类型
        let mimeType = "audio/webm";
        if (MediaRecorder.isTypeSupported("audio/webm;codecs=opus")) {
          mimeType = "audio/webm;codecs=opus";
        } else if (MediaRecorder.isTypeSupported("audio/mp4")) {
          mimeType = "audio/mp4";
        } else if (MediaRecorder.isTypeSupported("audio/wav")) {
          mimeType = "audio/wav";
        }

        this.mediaRecorder = new MediaRecorder(this.audioStream, {
          mimeType: mimeType,
        });
        this.recordedChunks = [];
        console.log("使用MIME类型:", mimeType);

        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.recordedChunks.push(event.data);
          }
        };
        this.mediaRecorder.onstop = () => {
          console.log("MediaRecorder停止录音");
          // 优先使用我们自建的WAV（更利于服务端ffmpeg提取时长）
          try {
            const wavBlob = this.buildWavFromPcm(
              this.pcmChunks,
              this.wavSampleRate
            );
            if (wavBlob && wavBlob.size > 0) {
              this.recordedBlob = wavBlob;
              console.log("WAV构建成功，大小:", this.recordedBlob.size);
            } else {
              // 退回MediaRecorder生成的容器
              const mimeType = this.mediaRecorder
                ? this.mediaRecorder.mimeType
                : "audio/webm;codecs=opus";
              this.recordedBlob = new Blob(this.recordedChunks, {
                type: mimeType,
              });
              console.log(
                "回退使用MediaRecorder容器，大小:",
                this.recordedBlob.size,
                "MIME类型:",
                mimeType
              );
            }
          } catch (e) {
            console.warn("构建WAV失败，回退MediaRecorder容器:", e);
            const mimeType = this.mediaRecorder
              ? this.mediaRecorder.mimeType
              : "audio/webm;codecs=opus";
            this.recordedBlob = new Blob(this.recordedChunks, {
              type: mimeType,
            });
          }
        };

        this.mediaRecorder.start(200); // 每200ms收集一次数据

        // 2. 启动AudioContext进行实时音频处理
        this.audioContext = new (window.AudioContext ||
          window.webkitAudioContext)({
          sampleRate: this.sampleRate,
        });
        
        // 获取实际的采样率（Mac可能不支持16000Hz）
        const actualSampleRate = this.audioContext.sampleRate;
        console.log(`目标采样率: ${this.sampleRate}Hz, 实际采样率: ${actualSampleRate}Hz`);
        
        // 保存实际采样率用于WAV构建
        this.wavSampleRate = this.sampleRate;
        this.actualSampleRate = actualSampleRate;
        
        // 判断是否需要重采样
        this.needsResampling = actualSampleRate !== this.sampleRate;
        if (this.needsResampling) {
          console.warn(`采样率不匹配，将从 ${actualSampleRate}Hz 重采样到 ${this.sampleRate}Hz`);
        }
        
        // 确保AudioContext处于running状态（Mac Safari需要）
        console.log("AudioContext初始状态:", this.audioContext.state);
        if (this.audioContext.state === 'suspended') {
          console.log("AudioContext处于suspended状态，尝试resume...");
          await this.audioContext.resume();
          console.log("AudioContext已resume，当前状态:", this.audioContext.state);
        }

        const source = this.audioContext.createMediaStreamSource(
          this.audioStream
        );
        
        // 调试：检查音频流状态
        const audioTrack = this.audioStream.getAudioTracks()[0];
        console.log("音频轨道状态:", {
          enabled: audioTrack.enabled,
          muted: audioTrack.muted,
          readyState: audioTrack.readyState,
          settings: audioTrack.getSettings()
        });
        
        const processor = this.audioContext.createScriptProcessor(4096, 1, 1);

        // 创建音频分析器用于获取音量
        this.analyser = this.audioContext.createAnalyser();
        this.analyser.fftSize = 256;
        this.analyser.smoothingTimeConstant = 0.8;
        
        // 修复Mac音频链路：processor直接从source获取数据
        // analyser并行连接用于音量检测
        source.connect(processor);
        source.connect(this.analyser);
        
        // 再次确认AudioContext状态
        console.log("连接完成后AudioContext状态:", this.audioContext.state);
        
        // 计数器用于调试
        let processCount = 0;
        let emptyCount = 0;

        processor.onaudioprocess = (event) => {
          processCount++;
          
          if (
            this.ws &&
            this.ws.readyState === WebSocket.OPEN &&
            !this.isPaused &&
            !this.waitingForFinal
          ) {
            const inputBuffer = event.inputBuffer;
            let inputData = inputBuffer.getChannelData(0);

            // 调试：检查原始音频数据
            const maxAmplitude = Math.max(...Array.from(inputData).map(Math.abs));
            const hasRawData = maxAmplitude > 0.001;
            
            if (!hasRawData) {
              emptyCount++;
              if (emptyCount <= 5 || emptyCount % 100 === 0) {
                console.warn(`原始音频数据为空或过小 (${emptyCount}/${processCount}), 最大振幅: ${maxAmplitude.toFixed(6)}`);
              }
              return;
            }
            
            // 首次收到有效数据时输出
            if (emptyCount > 0 && processCount === emptyCount + 1) {
              console.log(`✓ 开始接收有效音频数据，最大振幅: ${maxAmplitude.toFixed(4)}`);
            }

            // 如果需要重采样，先进行重采样
            if (this.needsResampling) {
              inputData = this.resampleAudio(inputData, actualSampleRate, this.sampleRate);
            }

            // 转换为16位PCM
            const pcmData = this.convertToPCM16(inputData);
            
            // 发送数据
            this.ws.send(pcmData);
            // 累积用于生成WAV（不影响实时转写）
            this.pcmChunks.push(new Int16Array(pcmData));
            // 保存上送的PCM数据用于调试播放
            this.sentPcmChunks.push(new Int16Array(pcmData));
          }
        };

        processor.connect(this.audioContext.destination);

        this.audioProcessor = processor;
        this.audioSource = source;
        
        // 启动音量检测
        this.startVolumeMonitoring();

        console.log("AudioContext和MediaRecorder录音开始");
        resolve(true);
      } catch (error) {
        console.error("AudioContext初始化失败:", error);
        // 降级到仅使用MediaRecorder
        this.fallbackToMediaRecorder()
          .then(resolve(true))
          .catch(resolve(false));
      }
    });
  }
  //   停止录音
  async stopRecording(onComplete = null) {
    // 保存回调函数
    this.onStopCompleteCallback = onComplete;

    // 立即停止音频流，防止继续上传
    if (this.audioStream) {
      this.audioStream.getTracks().forEach((track) => track.stop());
      this.audioStream = null;
      console.log("已停止音频流");
    }
    // 停止MediaRecorder
    if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
      this.mediaRecorder.stop();
      console.log("已停止MediaRecorder");
    }
    // 暂停AudioContext，停止音频处理
    if (this.audioContext && this.audioContext.state === "running") {
      this.audioContext.suspend();
      console.log("已暂停AudioContext");
    }

    // 如果还未收到过停止信号，那么就发送一次停止信号 （适用于录音未达到时长，用户手动停止的场景）
    if (
      !this.isFinalReceived &&
      this.ws &&
      this.ws.readyState === WebSocket.OPEN
    ) {
      // 发送停止消息
      this.ws.send(
        JSON.stringify({
          type: "stop",
          sessionId: window.localStorage.getItem("sessionId_AI"),
        })
      );

      // 发送空的二进制消息表示结束
      this.ws.send(new ArrayBuffer(0));

      // 设置等待final消息的标志
      this.waitingForFinal = true;
      console.log("已发送停止消息，等待final响应...");

      // 设置超时保护，最多等待10秒
      this.finalTimeout = setTimeout(() => {
        if (this.waitingForFinal) {
          console.warn("等待final消息超时，强制断开连接");
          this.executeStopRecordingProcess();
        }
      }, 10000);
    } else {
      // 如果没有WebSocket连接，直接完成停止流程
      this.executeStopRecordingProcess();
    }
  }
  // 暂停录音
  pauseRecording() {
    try {
      if (!this.isRecording || this.isPaused) {
        console.warn("当前不在录音状态或已暂停");
        return;
      }

      console.log("暂停录音...");
      this.isPaused = true;
      this.pauseTimer();

      // 发送暂停消息给后端
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(
          JSON.stringify({
            type: "pause",
          })
        );
      }

      // 暂停AudioContext（但不断开WebSocket）
      if (this.audioContext && this.audioContext.state === "running") {
        this.audioContext.suspend();
        console.log("AudioContext已暂停");
      }

      // 暂停MediaRecorder
      if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
        this.mediaRecorder.pause();
        console.log("MediaRecorder已暂停");
      }
    } catch (error) {
      console.error("暂停录音失败:", error);
    }
  }
  // 恢复录音
  resumeRecording() {
    try {
      if (!this.isRecording || !this.isPaused) {
        console.warn("当前不在录音状态或未暂停");
        return;
      }

      console.log("恢复录音...");
      this.isPaused = false;
      this.resumeTimer();

      // 发送恢复消息给后端
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        const resumeMessage = {
          type: "start",
          sampleRate: this.sampleRate,
          bits: this.bits,
          channels: this.channels,
          enablePunc: true,
          modelName: "bigmodel",
        };
        this.ws.send(JSON.stringify(resumeMessage));
      }

      // 恢复AudioContext
      if (this.audioContext && this.audioContext.state === "suspended") {
        this.audioContext.resume();
        console.log("AudioContext已恢复");
      }

      // 恢复MediaRecorder
      if (this.mediaRecorder && this.mediaRecorder.state === "paused") {
        this.mediaRecorder.resume();
        console.log("MediaRecorder已恢复");
      }
    } catch (error) {
      console.error("恢复录音失败:", error);
    }
  }
  // 接受停止信号
  handleFinalSignal() {
    // 由后端触发
    this.isFinalReceived = true;
    console.log("收到了后端返回的停止信号");
    // 这里要判断本次信号由谁触发
    if (this.isEndedByUser) {
      // 由用户手动触发
      // 直接执行停止录音流程
      this.executeStopRecordingProcess();
    } else {
      // 这里默认为达到录音时长
      this.isPausedByMaxDuration = true;
      this.pauseRecording();
    }
  }
  // 执行停止录音流程
  executeStopRecordingProcess() {
    try {
      // 清除等待标志和超时定时器
      this.waitingForFinal = false;
      if (this.finalTimeout) {
        clearTimeout(this.finalTimeout);
        this.finalTimeout = null;
      }

      // 关闭WebSocket连接
      if (this.ws && this.ws.readyState !== WebSocket.CLOSED) {
        try {
          this.ws.close();
          console.log("收到final消息后关闭WebSocket");
        } catch (e) {
          console.warn("关闭WebSocket失败:", e);
        }
      }
      this.ws = null;

      // 延迟检查录音数据，等待MediaRecorder的onstop事件完成
      setTimeout(() => {
        // 执行停止录音完成后的回调
        if (
          this.onStopCompleteCallback &&
          typeof this.onStopCompleteCallback === "function"
        ) {
          console.log("执行停止录音完成回调");
          this.onStopCompleteCallback();
          this.onStopCompleteCallback = null; // 清空回调
        }
      }, 500);
    } catch (error) {
      console.error("处理final消息失败:", error);

      // 即使出错也要执行回调
      if (
        this.onStopCompleteCallback &&
        typeof this.onStopCompleteCallback === "function"
      ) {
        console.log("出错时执行停止录音完成回调");
        this.onStopCompleteCallback();
        this.onStopCompleteCallback = null;
      }
    }
  }
  // 重置录音状态的方法
  resetRecordingState() {
    this.isRecording = false;
    this.isPaused = false;
    this.isPausedByMaxDuration = false;
    this.isEndedByUser = false;
    this.isFinalReceived = false;
    this.stopTimer();
    this.stopVolumeMonitoring();

    // 清理AudioContext资源
    if (this.audioProcessor) {
      try {
        this.audioProcessor.disconnect();
        console.log("已断开AudioProcessor");
      } catch (e) {
        console.warn("断开AudioProcessor失败:", e);
      }
      this.audioProcessor = null;
    }

    if (this.audioSource) {
      try {
        this.audioSource.disconnect();
        console.log("已断开AudioSource");
      } catch (e) {
        console.warn("断开AudioSource失败:", e);
      }
      this.audioSource = null;
    }

    if (this.audioContext && this.audioContext.state !== "closed") {
      try {
        this.audioContext.close();
        console.log("已关闭AudioContext");
      } catch (e) {
        console.warn("关闭AudioContext失败:", e);
      }
      this.audioContext = null;
    }

    // 清理MediaRecorder资源
    if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
      try {
        this.mediaRecorder.stop();
        console.log("已停止MediaRecorder");
        // 延迟清空mediaRecorder，等待onstop事件完成
        setTimeout(() => {
          this.mediaRecorder = null;
          console.log("已清空MediaRecorder引用");
        }, 100);
      } catch (e) {
        console.warn("停止MediaRecorder失败:", e);
        this.mediaRecorder = null;
      }
    } else {
      this.mediaRecorder = null;
    }

    if (this.audioStream) {
      try {
        this.audioStream.getTracks().forEach((track) => track.stop());
        console.log("已停止音频流");
      } catch (e) {
        console.warn("停止音频流失败:", e);
      }
      this.audioStream = null;
    }

    // 只有在不等待final消息时才关闭WebSocket
    if (
      !this.waitingForFinal &&
      this.ws &&
      this.ws.readyState !== WebSocket.CLOSED
    ) {
      try {
        // 发送结束标记
        this.ws.send(new ArrayBuffer(0));
        this.ws.close();
        console.log("已关闭WebSocket");
      } catch (e) {
        console.warn("关闭WebSocket失败:", e);
      }
      this.ws = null;
    } else if (this.waitingForFinal) {
      console.log("等待final消息中，暂不关闭WebSocket");
    }
    console.log("录音状态重置完成，按钮已启用");
  }

  // 音频重采样（线性插值法）
  resampleAudio(audioData, fromSampleRate, toSampleRate) {
    if (fromSampleRate === toSampleRate) {
      return audioData;
    }

    const ratio = fromSampleRate / toSampleRate;
    const newLength = Math.round(audioData.length / ratio);
    const result = new Float32Array(newLength);

    for (let i = 0; i < newLength; i++) {
      const position = i * ratio;
      const index = Math.floor(position);
      const fraction = position - index;

      if (index + 1 < audioData.length) {
        // 线性插值
        result[i] = audioData[index] * (1 - fraction) + audioData[index + 1] * fraction;
      } else {
        result[i] = audioData[index];
      }
    }

    return result;
  }

  // 转换Float32Array到16位PCM
  convertToPCM16(float32Array) {
    const buffer = new ArrayBuffer(float32Array.length * 2);
    const view = new DataView(buffer);
    let offset = 0;

    for (let i = 0; i < float32Array.length; i++, offset += 2) {
      let sample = Math.max(-1, Math.min(1, float32Array[i]));
      sample = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
      view.setInt16(offset, sample, true);
    }

    return buffer;
  }
  // 根据PCM16片段构建WAV Blob（PCM LE, 16-bit, mono）
  buildWavFromPcm(pcmChunks, sampleRate) {
    if (!pcmChunks || pcmChunks.length === 0) return null;
    // 计算总字节数
    const bytesPerSample = 2; // 16-bit
    let totalSamples = 0;
    for (const chunk of pcmChunks) {
      totalSamples += chunk.length;
    }
    const dataSize = totalSamples * bytesPerSample;
    const headerSize = 44;
    const totalSize = headerSize + dataSize;
    const buffer = new ArrayBuffer(totalSize);
    const view = new DataView(buffer);
    let pos = 0;

    // 写入WAV头（RIFF）
    const writeString = (s) => {
      for (let i = 0; i < s.length; i++) {
        view.setUint8(pos++, s.charCodeAt(i));
      }
    };

    // RIFF chunk descriptor
    writeString("RIFF"); // ChunkID
    view.setUint32(pos, totalSize - 8, true);
    pos += 4; // ChunkSize
    writeString("WAVE"); // Format

    // fmt sub-chunk
    writeString("fmt "); // Subchunk1ID
    view.setUint32(pos, 16, true);
    pos += 4; // Subchunk1Size (16 for PCM)
    view.setUint16(pos, 1, true);
    pos += 2; // AudioFormat (1 = PCM)
    view.setUint16(pos, 1, true);
    pos += 2; // NumChannels (mono)
    view.setUint32(pos, sampleRate, true);
    pos += 4; // SampleRate
    const byteRate = sampleRate * 1 * bytesPerSample;
    view.setUint32(pos, byteRate, true);
    pos += 4; // ByteRate
    const blockAlign = 1 * bytesPerSample;
    view.setUint16(pos, blockAlign, true);
    pos += 2; // BlockAlign
    view.setUint16(pos, 16, true);
    pos += 2; // BitsPerSample

    // data sub-chunk
    writeString("data");
    view.setUint32(pos, dataSize, true);
    pos += 4;

    // 写入PCM数据
    for (const chunk of pcmChunks) {
      for (let i = 0; i < chunk.length; i++, pos += 2) {
        view.setInt16(pos, chunk[i], true);
      }
    }

    return new Blob([buffer], { type: "audio/wav" });
  }
  // MediaRecorder降级方案
  fallbackToMediaRecorder() {
    return new Promise((resolve, reject) => {
      try {
        console.log("使用MediaRecorder降级方案");
        // 检查支持的MIME类型
        let mimeType = "audio/webm";
        if (MediaRecorder.isTypeSupported("audio/webm;codecs=opus")) {
          mimeType = "audio/webm;codecs=opus";
        } else if (MediaRecorder.isTypeSupported("audio/mp4")) {
          mimeType = "audio/mp4";
        } else if (MediaRecorder.isTypeSupported("audio/wav")) {
          mimeType = "audio/wav";
        }

        this.mediaRecorder = new MediaRecorder(this.audioStream, {
          mimeType: mimeType,
        });
        console.log("降级方案使用MIME类型:", mimeType);

        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            // 保存录音数据
            this.recordedChunks.push(event.data);

            if (
              this.ws &&
              this.ws.readyState === WebSocket.OPEN &&
              !this.isPaused &&
              !this.waitingForFinal
            ) {
              // 注意：这里发送的是编码后的音频，可能需要后端解码
              event.data.arrayBuffer().then((buffer) => {
                console.log("发送音频数据 (MediaRecorder):", buffer.byteLength);
                this.ws.send(buffer);
              });
            }
          }
        };

        this.mediaRecorder.onstart = () => {
          console.log("MediaRecorder开始录音");
          this.recordedChunks = []; // 重置录音数据
          resolve();
        };

        this.mediaRecorder.onstop = () => {
          console.log("MediaRecorder停止录音");
          // 使用更具体的MIME类型
          const mimeType = this.mediaRecorder
            ? this.mediaRecorder.mimeType
            : "audio/webm;codecs=opus";
          this.recordedBlob = new Blob(this.recordedChunks, { type: mimeType });
          console.log(
            "录音文件大小:",
            this.recordedBlob.size,
            "MIME类型:",
            mimeType
          );

          // 如果有转写文字，显示上传区域
          if (this.fullTranscript.trim()) {
          }
        };

        this.mediaRecorder.onerror = (event) => {
          console.error("MediaRecorder错误:", event.error);
          reject(event.error);
        };

        // 每200ms发送一次数据
        this.mediaRecorder.start(200);
      } catch (error) {
        reject(error);
      }
    });
  }
  updateFullTranscript(seq, text) {
    if (typeof seq !== "number") return;
    const clean = (text || "").trim();
    this.segmentTexts[seq] = clean;
    const ordered = Object.keys(this.segmentTexts)
      .map((k) => parseInt(k, 10))
      .sort((a, b) => a - b)
      .map((k) => this.segmentTexts[k])
      .filter((t) => t && t.length > 0);
    this.fullTranscript = ordered.join(" ");
    console.log("完整转写文字:", this.fullTranscript);
    
    // 触发转写文字更新回调
    if (this.onTranscriptUpdateCallback && typeof this.onTranscriptUpdateCallback === "function") {
      this.onTranscriptUpdateCallback(this.fullTranscript);
    }
  }

  // ===== 计时器相关方法 =====

  // 启动计时器
  startTimer() {
    this.startTime = Date.now();
    this.totalPausedDuration = 0;
    this.currentTime = 0;
    this.currentTimeMs = 0;
    this.formattedTime = "00:00";

    this.timerInterval = setInterval(() => {
      if (!this.isPaused) {
        this.currentTime =
          Date.now() - this.startTime - this.totalPausedDuration;
        // 实时更新外部可访问的字段
        this.currentTimeMs = this.currentTime;
        this.updateFormattedTime();

        // 检查是否达到最大录音时长
        if (
          this.currentTimeMs >= this.defaultMaxDuration &&
          !this.isPausedByMaxDuration
        ) {
          console.log("录音时长已达到最大限制，自动暂停录音");
          this.isPausedByMaxDuration = true;
          this.pauseRecording();
        }
      }
    }, 10); // 每10毫秒更新一次，确保精确度

    console.log("计时器已启动");
  }

  // 暂停计时器
  pauseTimer() {
    if (this.timerInterval && this.pausedTime === 0) {
      this.pausedTime = Date.now();
      console.log("计时器已暂停");
    }
  }

  // 恢复计时器
  resumeTimer() {
    if (this.pausedTime > 0) {
      this.totalPausedDuration += Date.now() - this.pausedTime;
      this.pausedTime = 0;
      console.log("计时器已恢复");
    }
  }

  // 停止计时器
  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
    this.resetTimer();
    console.log("计时器已停止并重置");
  }

  // 重置计时器
  resetTimer() {
    this.startTime = null;
    this.pausedTime = 0;
    this.totalPausedDuration = 0;
    this.currentTime = 0;
    this.currentTimeMs = 0;
    this.formattedTime = "00:00";
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  // 更新格式化时间（内部方法）
  updateFormattedTime() {
    const totalSeconds = Math.floor(this.currentTimeMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    this.formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  }

  // ===== 音量监测相关方法 =====
  
  // 启动音量监测
  startVolumeMonitoring() {
    if (!this.analyser) return;
    
    const bufferLength = this.analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    
    this.volumeCheckInterval = setInterval(() => {
      if (this.isPaused || !this.isRecording) return;
      
      this.analyser.getByteFrequencyData(dataArray);
      
      // 计算平均音量
      let sum = 0;
      for (let i = 0; i < bufferLength; i++) {
        sum += dataArray[i];
      }
      const average = sum / bufferLength;
      
      // 归一化到 0-1 范围
      const normalizedVolume = average / 255;
      
      // 触发音量更新回调
      if (this.onVolumeUpdateCallback && typeof this.onVolumeUpdateCallback === 'function') {
        this.onVolumeUpdateCallback(normalizedVolume);
      }
    }, 50); // 每50ms更新一次
    
    console.log("音量监测已启动");
  }
  
  // 停止音量监测
  stopVolumeMonitoring() {
    if (this.volumeCheckInterval) {
      clearInterval(this.volumeCheckInterval);
      this.volumeCheckInterval = null;
      console.log("音量监测已停止");
    }
  }

  // 上传录音文件
}
